import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 520,
          width: '100%',
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          border: '1px solid',
          borderColor: 'divider',
          textAlign: 'center',
        }}
      >
        <Stack spacing={2.5} alignItems="center">
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              bgcolor: 'error.lighter',
              color: 'error.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ShieldAlert size={28} />
          </Box>
          <Box>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              Access restricted
            </Typography>
            <Typography variant="body2" color="text.secondary">
              You don&apos;t have permission to view this page. Please contact your administrator
              if you believe this is a mistake.
            </Typography>
          </Box>
          <Stack direction="row" spacing={1.5}>
            <Button variant="contained" onClick={() => navigate('/')}>
              Go to Dashboard
            </Button>
            <Button variant="outlined" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

export default Unauthorized;
